import { AxiosResponse } from "axios";
import { normalize, schema } from 'normalizr';
import { createAsyncThunk } from "@reduxjs/toolkit";
import mineCraftApi from '../../api/mineCraftApi';
import { ProductInterface } from "../../store/mine_craft/productsSlice";

const PREFIX = 'mine_craft';

const processStrategy = (value: any) => {
  return { ...value };
}

const productsEntity = new schema.Entity(
  'products',
  {},
  {
    processStrategy
  }
);

const productEntity = new schema.Entity(
  'product',
  {},
  {
    processStrategy
  }
);

const normalizeInstance = (response: AxiosResponse) => {
  const normalized = normalize<any, { product: ProductInterface }>(response.data.product, productEntity);
  return normalized.entities;
}

export const normalizeCollection = (response: AxiosResponse) => {
  const normalized = normalize<
    any,
    {
      products: { [key: string]: ProductInterface },
    }
  >(response.data.products, [productsEntity]);

  return {
    products: normalized.entities?.products || {},
    ids: normalized.result,
    count: response.data.meta?.total_count
  };
}

export const fetchProducts = createAsyncThunk(
  `${PREFIX}_products/fetchProducts`,
  async (params: object = {}) => {
    const response = await mineCraftApi.get(`/onesky/products`, { params });
    return normalizeCollection(response);
  }
);

export const fetchProduct = createAsyncThunk(
  `${PREFIX}_products/fetchProduct`,
  async (id: number | string) => {
    const response = await mineCraftApi.get(`/onesky/products/${id}`);
    return normalizeInstance(response);
  }
);

export const createProduct = createAsyncThunk(
  `${PREFIX}_products/createProduct`,
  async (data: object, { rejectWithValue }) => {
    try {
      const response = await mineCraftApi.post(`/onesky/products`, data);
      return normalizeInstance(response);
    } catch (error: any) {
      return rejectWithValue(error?.response?.data || error);
    }
  }
);

export const updateProduct = createAsyncThunk(
  `${PREFIX}_products/updateProduct`,
  async ({ id, data }: { id: number, data: object }, { rejectWithValue }) => {
    try {
      const response = await mineCraftApi.patch(`/onesky/products/${id}`, data);
      return normalizeInstance(response);
    } catch (error: any) {
      return rejectWithValue(error.response.data || error)
    }
  }
);

export const destroyProduct = createAsyncThunk(
  `${PREFIX}_products/destroyProduct`,
  async (id: number) => {
    await mineCraftApi.delete(`/onesky/products/${id}`);
    return { id: id };
  }
);
